import React, { useMemo, useState } from 'react'
import { MdOutlineWorkHistory } from 'react-icons/md'

import { IPageConfig } from '@/Core/Contracts/Loaders/IPageConfig'
import { ResourceList } from '@/Core/UI/CrudResource/ResourceList'
import { createCrudResourceContext } from '@/Core/UI/CrudResource/CrudResourceContextProvider'
import { MultiShiftDrawer } from '../Components/MultiShiftDrawer'
import { ShiftResource } from '../Resources/ShiftResource'
import { MultiShiftDrawerStore } from '../Stores/MultiShiftDrawerStore'

const ShiftPage: React.FC = () => {
    const [multiStore] = useState(() => new MultiShiftDrawerStore())

    const listContext = useMemo(() => {
        const ctx = createCrudResourceContext({
            contextType: 'list',
            registryKey: 'Shift.Shift.list',
            resource: ShiftResource,
        } as any)
        // Кнопка «Додати кілька» (ShiftResource.headerPage) відкриває вікно через цей стор
        ;(ctx as any).setStorage?.('multiShiftStore', multiStore)
        return ctx
    }, [multiStore])

    return (
        <>
            <ResourceList crudContext={listContext} registryKey="Shift.Shift.list" />
            {/* load(true): actions.reload() бере список із 30-секундного кешу GET у restClient — нових змін не видно */}
            <MultiShiftDrawer
                store={multiStore}
                onCreated={() => (listContext as any)?.listContext?.actions?.load?.(true)}
            />
        </>
    )
}

export default ShiftPage

export const pageConfig: IPageConfig = {
    route: '/shifts',
    title: 'Зміни',
    icon: <MdOutlineWorkHistory />,
}
